<template>
  <!-- 店铺信息-申请店铺 -->
  <div class="Case-box">
    <!-- 申请 -->
    <div class="top-title">
      <div class="content">
        <div class="examine" v-if="DisplayPage == '3'"></div>
        <div class="picture" v-else></div>
        <p class="Tips" v-if="DisplayPage == '3'">审核中</p>
        <p class="Tips" v-if="DisplayPage == '2'">暂时没有开通店铺</p>
        <p class="ApplyNow" v-if="DisplayPage == '2'" @click="handelApplyFor">立即申请</p>
        <p class="Tips" v-if="DisplayPage == '4'">审核失败</p>
        <p class="ApplyNow" v-if="DisplayPage == '4'" @click="handelApplyFor">重新申请</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    DisplayPage: {},
  },
  data() {
    return {};
  },
  watch: {},
  components: {},
  created() {},
  methods: {
    // 返回
    handelBack() {
      this.$emit("handelBack");
    },
    // 立即申请
    handelApplyFor(){
      this.$emit("handelApplyFor");
    },
  },
};
</script>

<style scoped lang="less">
// 外层div
.Case-box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .top-title {
    width: 100%;
    height: 400px;
    display: flex;
    .content {
      width: 250px;
      height: 400px;
      margin: auto;
      margin-top: 100px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #666666;
      text-align: center;
      font-weight: 400;
      .examine {
        width: 250px;
        height: 250px;
        background-image: url("../../../../../assets/imgs/img/1745726046988.jpg");
        background-size: 100% 100%;
      }
      .picture {
        width: 250px;
        height: 250px;
        background-image: url("../../../../../assets/imgs/zanweikaitong@3x.svg");
        background-size: 100% 100%;
      }
      .Tips {
        width: 100%;
        height: 18px;
        line-height: 18px;
        margin-top: 20px;
        margin-bottom: 50px;
      }
      .ApplyNow {
        width: 200px;
        height: 40px;
        line-height: 40px;
        background: #409eff ;
        border-radius: 10px;
        color: #ffffff;
        margin: 0 auto;
      }
    }
  }
}
</style>
